import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, program} = contexts;

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    title: i18n.t('notifications:end_of_program_reminder.title', {
      clientName: course?.client?.name,
      programTitle: program?.title,
    }),
  };
};
